import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import Pagination from '@/components/Pagination.vue'
import Keys from '@/constant/key'
import { useRouter } from 'vue-router'
import { joinParams } from '@/utils/index'
import { useStore } from '@/store/index'
import { getCurrentInstance, reactive, ref } from 'vue'
import { getCancelledCouponListApi, updateCancelledCouponStatusApi } from '@/apis/electron'
import SelectBrand from '@/components/SelectBrand.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelledList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const userId = store.state.user.userInfo.id
const router = useRouter()
const filters = reactive({
    brand_id: '', // 品牌名称
    status: '',  // 券码状态
    start_date: '', // 开始时间
    end_date: '', // 结束时间
    page: 1, // 当前页码
    page_size: 10, // 每页显示条数
})

// 品牌筛选条件
const onBrandChange = (val) => {
    filters.brand_id = val
}

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getCancelledCouponListApi(filters) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    tableData.value = data.data
    total.value = data.total
}
getList()

// 导出
const onExport = () => {
    window.open(`${Keys.baseUrl}/cake/couponRefundExport?${joinParams({ ...filters, user_id: userId })}`);
}

/**********************  批量更新状态 --begin **********************/
// 批量更新状态弹框
const updateDialog = ref(false)
// 关闭弹框前清空已上传文件列表
const beforeUpdateDialogClose = () => {
    proxy.$refs.upload.clearFiles()
    updateDialog.value = false
}
// 手动上传
const onUpload = () => {
    proxy.$refs.upload.submit()
}
// 上传成功后关闭弹框同时清空文件
const onUploadSuccess = (res) => {
    const {code, data, msg} = res
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    proxy.$message({ type: 'success', message: '操作成功' })

    beforeUpdateDialogClose()
    getList()
}
/**********************  批量更新状态 --end **********************/

// 打开券码详情窗口
const rowData = ref<any>([])
const detailDialog = ref(false)
const openDetailDialog = (couponInfo: object) => {
    rowData.value[0] = couponInfo
    detailDialog.value = true
}

// 操作提示弹框
const openConfirm = (type: number, row: any) => {
    proxy.$confirm(type === 1 ? '确认恢复该数据继续售卖' : '作废后，该券不可售卖', '提示', {
        type: 'warning'
    }).then(() => {
        updateCancelledCouponStatusApi(row.id, type).then(res => {
            const { code, data, msg } = res as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '操作成功' })
            getList()
        })
    }).catch(() => {
        console.log('取消操作')
    })
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, {
        ifBody: 2,
        onBrandChange: onBrandChange
      }),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.status) = $event)),
        placeholder: "券码状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待确认",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已恢复",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "已作废",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "退款开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "退款结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (updateDialog.value = true))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("批量更新状态")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "coupon_id",
          label: "卡号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_no",
          label: "券码"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "类型"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.type == 1 ? '自制' : '采购'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "券码信息",
          width: "220"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, "券码ID：" + _toDisplayString(scope.row.coupon_info.id), 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", null, "券码名称：" + _toDisplayString(scope.row.coupon_info.coupon_name), 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", null, "券码状态：" + _toDisplayString(scope.row.coupon_info.status == 1 ? '已使用' : '未使用'), 1),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", null, "有效期：" + _toDisplayString(scope.row.coupon_info.valid_from) + "至" + _toDisplayString(scope.row.coupon_info.valid_to), 1),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (openDetailDialog(scope.row.coupon_info))
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("详情")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "券码状态"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status == 0 ? '待确认' : scope.row.status == 1 ? '已恢复' : '已作废'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "退款时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "165"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (openConfirm(1, scope.row)),
                disabled: scope.row.status != 0
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("继续售卖")
                ])),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (openConfirm(2, scope.row)),
                disabled: scope.row.status != 0
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("真作废")
                ])),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "券码详情信息",
      modelValue: detailDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((detailDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: rowData.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "券码ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "coupon_name",
              label: "券码名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "coupon_no",
              label: "卡号"
            }),
            _createVNode(_component_el_table_column, { label: "密码" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.password ? scope.row.password : '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "使用状态" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.status == 1 ? '已使用' : '未使用'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "有效期",
              width: "180px"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.valid_from) + " 至 " + _toDisplayString(scope.row.valid_to), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量更新状态",
      modelValue: updateDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updateDialog).value = $event)),
      "before-close": beforeUpdateDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeUpdateDialogClose }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onUpload
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "upload",
                  action: `/api/cake/except_return_coupon?user_id=${_unref(userId)}`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/cake/couponRefundExport?start_date=2024-01-01&end_date=2024-01-01`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("下载批量更新状态模板")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})